import { Component, OnDestroy, OnInit, ViewChild, inject } from '@angular/core';
import { first, Subscription } from 'rxjs';
import { CheckoutObject } from '../../../../models/checkout';
import { CartKeyService } from '../../../../services/cart-key/cart-key.service';
import { CartService } from '../../../../services/cart/cart.service';
import { GungModalService } from '../../../../services/gung-modal/gung-modal.service';
import { PunchoutFormComponent } from '../punchout-form/punchout-form.component';
import { CheckoutStepComponent } from '../../steps/base/checkout-step.component';

@Component({
  selector: 'lib-punchout-submit-step',
  templateUrl: './punchout-submit-step.component.html',
  styleUrls: ['./punchout-submit-step.component.scss'],
  standalone: false
})
export class PunchoutSubmitStepComponent extends CheckoutStepComponent implements OnInit, OnDestroy {
  protected cartKeyService = inject(CartKeyService);
  protected cartService = inject(CartService);
  protected gungModalService = inject(GungModalService);

  @ViewChild(PunchoutFormComponent) punchoutForm?: PunchoutFormComponent;

  submitting = false;
  orderPosted = false;
  formReady = false;
  orderSubmitError: { show: boolean; error?: any } = { show: false };

  private nextSubscription?: Subscription;

  ngOnInit(): void {
    this.disableNextButton.emit(true);
    this.nextSubscription = this.onNextBtnClicked.subscribe(() => this.submitPunchoutOrder());
  }

  ngOnDestroy(): void {
    this.nextSubscription?.unsubscribe();
  }

  onPunchoutFormReady(): void {
    this.formReady = true;
    this.submitPunchoutOrder();
  }

  onPunchoutFormFailed(error: unknown): void {
    this.orderSubmitError.error = error;
    this.orderSubmitError.show = true;
    this.submitting = false;
    this.disableNextButton.emit(true);
  }

  protected submitPunchoutOrder(): void {
    if (this.submitting || !this.formReady) {
      return;
    }

    if (this.checkout.rows.length === 0) {
      this.gungModalService
        .openConfirmYesNoModal('ERROR', 'ERROR_SUBMIT_ORDER_EMPTY_CART', { size: 'sm' }, 'OK', null)
        .then(() => this.stepPrevious.emit(this.checkout));
      return;
    }

    this.submitting = true;
    this.orderPosted = false;
    this.orderSubmitError.show = false;
    this.disableNextButton.emit(true);

    const submitted = this.punchoutForm?.submit();
    if (!submitted) {
      this.onPunchoutFormFailed('Punchout form is not ready.');
      return;
    }

    this.orderPosted = true;
    this.cartKeyService
      .getCurrentCartKey()
      .pipe(first())
      .subscribe(key => {
        localStorage.removeItem(key);
        this.cartService.clearCart();
      });
  }

  getLabel(): string {
    return 'CONFIRM';
  }

  public getBtnTexts(_checkout?: CheckoutObject): { next: string | void; prev: string | void } | void {
    return {
      next: 'SUBMIT_ORDER',
      prev: null
    };
  }

  public isVisible(): boolean {
    return false;
  }
}
